import React from 'react';
import PropTypes from 'prop-types';

// components
import { PriceAmount } from './PriceAmount';

// helpers
import { getAmountByCurrency } from './helpers';

/**
 * Price Components for an item with just a retail price
 */
export function RetailItemPrices({ currency, pricing, showListPriceLabel, quantityDisplay }) {
    const { retailPrice } = pricing;
    const retailAmount = getAmountByCurrency(retailPrice, currency);

    // RETAIL PRICE
    return (
        <PriceAmount
            currency={currency}
            amount={retailAmount}
            showLabel={showListPriceLabel}
            quantityDisplay={quantityDisplay}
        />
    );
}

RetailItemPrices.propTypes = {
    currency: PropTypes.string,
    showListPriceLabel: PropTypes.bool,
    quantityDisplay: PropTypes.string,
    pricing: PropTypes.shape({
        retailPrice: PropTypes.object.isRequired,
    }).isRequired,
};
